(function () {
  function norm(s) {
    return (s || '').trim().toLowerCase();
  }

  function familySlug(family) {
    return (family || '')
      .toLowerCase()
      .replace(/&/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function moodDatasetKey(slug) {
    return 'mood' + slug.split('-').map(function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }).join('');
  }

  var cache = null;
  function loadData(url) {
    if (cache) return Promise.resolve(cache);
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var map = {};
        data.forEach(function (entry) {
          var aliases = entry.aliases && entry.aliases.length ? entry.aliases : [entry.name];
          aliases.concat([entry.name]).forEach(function (a) {
            map[norm(a)] = entry;
          });
        });
        cache = map;
        return map;
      });
  }

  function hasDedicatedPhoto(sectionId) {
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return false;
    var img = gallery.querySelector('.product__media-item img');
    if (!img) return false;
    var src = img.currentSrc || img.src || '';
    return /\/rg-scent-/.test(src);
  }

  function currentScentValue(variantSelects) {
    var select = variantSelects.querySelector('select[name="options[Scent]"]');
    if (select) return select.value;
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && norm(legend.textContent).indexOf('scent') === 0) {
        var checked = fieldsets[i].querySelector('input:checked');
        if (checked) return checked.value;
      }
    }
    return null;
  }

  function wire(panel) {
    var sectionId = panel.getAttribute('data-section');
    var dataUrl = panel.getAttribute('data-scent-url');

    function variantSelectsEl() {
      return document.getElementById('variant-selects-' + sectionId);
    }

    function render(value) {
      loadData(dataUrl).then(function (map) {
        var entry = map[norm(value)];
        // Re-query on every render, not just once at wire-time: Dawn
        // replaces the variant-selects DOM subtree (including the
        // <select> itself) on every variant change via an AJAX section
        // reload, and can replace this panel's own children along with
        // it. Cached references from wire() go stale after the first
        // swap, which is why family/description used to freeze on the
        // second+ scent change while the image (updated by Dawn's own
        // gallery code, not this script) kept working.
        var familyEl = panel.querySelector('[data-rg-scent-family]');
        var descEl = panel.querySelector('[data-rg-scent-desc]');
        var moodImg = panel.querySelector('[data-rg-scent-mood-img]');
        var moodWrap = moodImg ? moodImg.closest('.rg-scent-info__mood') : null;

        if (entry && familyEl && descEl) {
          familyEl.textContent = entry.family;
          descEl.textContent = entry.description;
          panel.hidden = false;

          if (moodImg && moodWrap) {
            var slug = familySlug(entry.family);
            var url = panel.dataset[moodDatasetKey(slug)];
            // Skip the generic family mood photo whenever this scent
            // already has its own dedicated photo (filename starts with
            // "rg-scent-") as its real gallery image - showing a
            // family-generic thumbnail next to a specific, correct one
            // reads as a mismatch (e.g. an apple thumbnail next to a
            // scent-accurate pear photo). Per John, 2026-08-26.
            if (url && !hasDedicatedPhoto(sectionId)) {
              moodImg.src = url;
              moodImg.alt = entry.family + ' fragrance mood';
              moodWrap.hidden = false;
            } else {
              moodWrap.hidden = true;
            }
          }
        } else {
          panel.hidden = true;
        }
      });
    }

    var initialSelects = variantSelectsEl();
    if (initialSelects) {
      var initial = currentScentValue(initialSelects);
      if (initial) render(initial);
    }

    // Delegate on document instead of binding to variantSelects directly:
    // that node gets replaced on every variant change, so a listener
    // attached to it only ever fires once. document never gets replaced,
    // and native 'change' events bubble, so this keeps working no matter
    // how many times Dawn swaps the section underneath it.
    document.addEventListener('change', function (evt) {
      var selects = variantSelectsEl();
      if (!selects || !selects.contains(evt.target)) return;
      var v = currentScentValue(selects);
      if (v) render(v);
    });
  }

  function init() {
    document.querySelectorAll('[data-rg-scent-info]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
